export default __webpack_public_path__ + "static/media/ID_3.050b4dec.png";